/**
 * Matches an authored image that needs shared masonry layout, or
 * member-content markup that may introduce one after decryption. Split into
 * its own module (no observer code) so the published runtime can check for a
 * layout target cheaply and only load the heavier layout module when one
 * exists, keeping image-free pages out of the initial transfer budget.
 */
export const PUBLISHED_IMAGE_LAYOUT_SELECTOR = "[data-tiptap-image], taproot-member-content";
